export default __webpack_public_path__ + "static/media/hair-0-2.346c75f7.svg";